var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"stepComponent"}},[_c('ul',{staticClass:"process--ul"},_vm._l((_vm.steps),function(step){return _c('li',{key:step.id,class:_vm.liClass(step)},[_vm._v(_vm._s(step.stepName))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }